import instance from "@/utils/require.js"

// 产测工具--分页查询
export function apiFactoryToolsSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/search",
		method: "post",
		data
	})
}

// 产测工具--新增工具
export function apiFactoryToolsAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/add",
		method: "post",
		data
	})
}

// 产测工具--版本发布
export function apiFactoryToolsHisAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/add_tool_version",
		method: "post",
		data
	})
}
// 产测工具--修改版本
export function apiFactoryToolsHisEdit(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/edit_tool_version",
		method: "post",
		data
	})
}

// 产测工具--版本查询
export function apiFactoryToosHisSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/search_version",
		method: "post",
		data
	})
}

// 产测工具--产品类别下拉
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 产测工具--修改版本
export function apiToolsUpdateVersion(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/update/version",
		method: "post",
		data
	})
}

// 产测工具--禁用
export function apiFactoryToolsDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/disable",
		method: "post",
		data
	})
}

// 产测工具--启用
export function apiFactoryToolsEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/enable",
		method: "post",
		data
	})
}

// 产测工具--下移
export function apiFactoryToolsMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/move_down",
		method: "post",
		data
	})
}

// 产测工具--下移
export function apiFactoryToolsMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/move_up",
		method: "post",
		data
	})
}
// 产测工具--排序
export function apiFactoryToolsDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/drag_sort",
		method: "post",
		data
	})
}

// 产测工具--产测命令查询
export function apiFactoryCommandSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/search",
		method: "post",
		data
	})
}

// 产测工具--产测命令禁用
export function apiFactoryCommandDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/disable",
		method: "post",
		data
	})
}

// 产测工具--产测命令启用
export function apiFactoryCommandEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/enable",
		method: "post",
		data
	})
}

// 产测工具--产测命令下移
export function apiFactoryCommandMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/move_down",
		method: "post",
		data
	})
}

// 产测工具--产测命令下移
export function apiFactoryCommandMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/move_up",
		method: "post",
		data
	})
}

// 产测工具--产测命令排序
export function apiFactoryCommandDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/drag_sort",
		method: "post",
		data
	})
}

// 产测工具--所在工序下拉
export function apiFactoryStationList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/factory_station",
		method: "post",
		data
	})
}

// 产测工具--执行方式下拉
export function apiCommandTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/factory_command_type",
		method: "post",
		data
	})
}

// 产测工具--产测协议类型
export function apiFactoryAgreement(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/factory_agreement",
		method: "post",
		data
	})
}

// 产测工具--产测命令详情
export function apiFactoryCommandDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/detail",
		method: "post",
		data
	})
}

// 产测工具--添加产测命令
export function apiFactoryCommandAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/add",
		method: "post",
		data
	})
}

// 产测工具--修改产测命令
export function apiFactoryCommandUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_command/update",
		method: "post",
		data
	})
}

// 产测工具--生产站点查询
export function apiProductionActionSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/production_action/search",
		method: "post",
		data
	})
}

// 产测工具--生产站点禁用
export function apiProductionActionDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/production_action/disable",
		method: "post",
		data
	})
}

// 产测工具--生产站点启用
export function apiProductionActionEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/production_action/enable",
		method: "post",
		data
	})
}

// 产测工具--生产站点上移
export function apiProductionActionMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/production_action/move_up",
		method: "post",
		data
	})
}

// 产测工具--生产站点下移
export function apiProductionActionMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/production_action/move_down",
		method: "post",
		data
	})
}

// 工单详情--数据查询
export function apiFactoryToolDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_tools/detail",
		method: "post",
		data
	})
}
